export default "__VITE_ASSET__BBLqXePa__"